<template>
    <div class="col-12 mx-auto">
        <div>
            <div class="loader" v-show="working"></div>
            <div v-show="!working" :class="showInCard ? 'card' : ''">
                <div v-if="showDashboardCtrls">
                    <dashboard-ctrl :componentName="componentName"
                                    :showHideButton="showHideButton"
                                    :showPinButton="showPinButton"
                                    :showResizeIcon="showResizeIcon"
                                    :size="size"
                                    :headerTitle="titleKey"
                                    :componentClass="'card-header bg-primary text-white'"
                                    :showHeadful="showHeadful"
                                    @hide="hide"
                                    @resize="resize"
                                    @pinned="pinned"
                                    @unpinned="unpinned">
                    </dashboard-ctrl>
                </div>

                <div :class="showInCard ? 'card-header' : ''" v-if="showNewButton || showSettingsBtn">
                    <button type="button" class="btn btn-primary"
                            v-if="showNewButton && !hasEventId && hasFormCreateRights"
                            @click="createBtnClick">
                        {{$t('buttons.create.btnText')}}
                    </button>
                    <button type="button" class="btn btn-primary"
                            v-if="showAddButton && eventClaims['EVENTFORMMANAGEMENT'].create"
                            @click="addFormToEvent">
                        {{$t('buttons.add.btnText')}}
                    </button>

                    <span v-if="showformsGridSettings">
                        <i class="fas fa-cogs pointer fa-2x float-right text-primary"
                           @click.stop="changeGridSettings"
                           data-toggle="tooltip"
                           :title="settingsTooltipText"></i>
                    </span>

                    <div v-if="showformsGridSettings">
                        <GridUserSettings ref="formsGridSettings"
                                          :visible="showformsGridSettingsForm"
                                          :grid="$refs['formsGrid']"
                                          :componentName="componentName">
                        </GridUserSettings>
                    </div>
                </div>

                <div class="btn-toolbar justify-content-between" :class="showInCard ? 'mb-0 mt-2' : 'ml-0 mr-0 mt-2 mb-2'" role="toolbar">
                    <div class="col-sm-12 col-md-6">
                        <div v-show="!hasEventId">
                            <kendo-dropdownlist v-model="formsFilter"
                                                :data-source="formsFilterItems"
                                                :data-text-field="'text'"
                                                :data-value-field="'id'"
                                                :filter="'contains'"
                                                :clear-button="true"
                                                style="width: 100%;">
                            </kendo-dropdownlist>
                        </div>
                    </div>
                    <div class="input-group" :class="showSettingsBtn? '':'col-12'">
                        <input v-model="searchQuery" v-on:keyup.enter.stop="massSearch" v-on:keyup.esc.stop="clearFilters" type="text" class="form-control" aria-label="Mass search input" aria-describedby="massSearch">
                        <button class="btn btn-secondary" @click.stop="massSearch">
                            <i class="fas fa-search"></i>
                            {{ $t('buttons.search.btnText') }}
                        </button>
                        <button class="btn btn-secondary"
                                @click.stop="clearFilters">
                            <i class="fas fa-times"></i>
                            {{ $t('buttons.clearFilters.btnText') }}
                        </button>
                    </div>
                </div>

                <div :class="showInCard ? 'card-body' : ''" id="grid">
                    <kendo-datasource ref="datasource1"
                                      :transport="transportSettings"
                                      :schema-model-id="'id'"
                                      :schema-model-fields="schemaModelFields"
                                      :schema-total="'total'"
                                      :schema-data="'data'"
                                      :page-size='gridOptions.pageable.size'
                                      :server-paging="true"
                                      :server-sorting="true"
                                      :server-filtering="true"
                                      :error="dataSourceError"
                                      :requestEnd="datasorceRequestEnd">
                    </kendo-datasource>

                    <kendo-grid ref="formsGrid"
                                id="formsGrid"
                                :data-source-ref="'datasource1'"
                                :pageable="gridOptions.pageable"
                                :navigatable="gridOptions.navigatable"
                                :editable="gridOptions.editable"
                                :filterable="gridOptions.filterable"
                                :reorderable="gridOptions.reorderable"
                                :resizable="gridOptions.resizable"
                                :groupable="gridOptions.groupable"
                                :allow-copy="gridOptions.allowCopy"
                                :column-menu="gridOptions.columnMenu"
                                :sortable-mode="gridOptions.sortable.mode"
                                :sortable-allow-unsort="gridOptions.sortable.allowUnsort"
                                :sortable-show-indexes="gridOptions.sortable.showIndexes"
                                :selectable="gridOptions.selectable"
                                :scrollable="gridOptions.scrollable"
                                :toolbar="toolbar"
                                :excel="gridOptions.excel"
                                :pdf="gridOptions.pdf"
                                :data-bound="dataBound"
                                name="formsGrid">
                        <kendo-grid-column v-if="showBtns"
                                           :title="$t('actions')"
                                           field="btnsColumn"
                                           :sortable="false"
                                           :filterable="false"
                                           :template="btnsTemplate"
                                           :width="150"
                                           :lockable="true"
                                           :locked="false">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'id'"
                                           :filterable="false"
                                           :title="$t('registers.forms.gridHeaders.id')"
                                           :width="100"
                                           :hidden="true"
                                           :lockable="false"
                                           :locked="false">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'registerEntityId'"
                                           :filterable="false"
                                           :title="$t('registers.forms.gridHeaders.registerEntityId')"
                                           :width="100"
                                           :hidden="true"
                                           :lockable="false"
                                           :locked="false">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'formId'"
                                           :filterable="false"
                                           :title="$t('registers.forms.gridHeaders.formId')"
                                           :width="100"
                                           :hidden="true"
                                           :lockable="false"
                                           :locked="false">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'eventName'"
                                           :title="$t('registers.forms.gridHeaders.eventName')"
                                           :width="200"
                                           :lockable="true"
                                           :locked="false"
                                           :hidden="hasEventId">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'name'"
                                           :title="$t('registers.forms.gridHeaders.name')"
                                           :width="200"
                                           :lockable="true"
                                           :locked="false"
                                           :hidden="isEnVersion">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'nameEn'"
                                           :title="$t('registers.forms.gridHeaders.nameEn')"
                                           :width="200"
                                           :lockable="true"
                                           :locked="false"
                                           :hidden="!isEnVersion">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'formType'"
                                           :title="$t('registers.forms.gridHeaders.formType')"
                                           :width="200"
                                           :lockable="true"
                                           :locked="false"
                                           :hidden="isEnVersion">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'formTypeEn'"
                                           :title="$t('registers.forms.gridHeaders.formTypeEn')"
                                           :width="200"
                                           :lockable="true"
                                           :locked="false"
                                           :hidden="!isEnVersion">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'validFromUtc'"
                                           :title="$t('registers.forms.gridHeaders.validFrom')"
                                           :width="180"
                                           :format="customDateTimeFormat"
                                           :lockable="true"
                                           :locked="false">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'validToUtc'"
                                           :title="$t('registers.forms.gridHeaders.validTo')"
                                           :width="180"
                                           :format="customDateTimeFormat"
                                           :lockable="true"
                                           :locked="false">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'note'"
                                           :title="$t('registers.forms.gridHeaders.note')"
                                           :width="200"
                                           :lockable="true"
                                           :locked="false">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'isTemplate'"
                                           :title="$t('registers.forms.gridHeaders.isTemplate')"
                                           :width="150"
                                           :lockable="true"
                                           :locked="false"
                                           :template="isTemplateCellTemplate">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'deactivated'"
                                           :title="$t('registers.forms.gridHeaders.formToEventDeactivated')"
                                           :width="150"
                                           :lockable="true"
                                           :locked="false"
                                           :template="formToEventDeactivatedCellTemplate">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'status'"
                                           :title="$t('registers.forms.gridHeaders.status')"
                                           :width="150"
                                           :lockable="true"
                                           :locked="false"
                                           :template="statusCellTemplate">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'isAnonymous'"
                                           :title="$t('registers.forms.gridHeaders.isAnonymous')"
                                           :width="150"
                                           :lockable="true"
                                           :locked="false"
                                           :template="isAnonymousCellTemplate">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'isAuthorHidden'"
                                           :title="$t('registers.forms.gridHeaders.isAuthorHidden')"
                                           :width="150"
                                           :lockable="true"
                                           :locked="false"
                                           :template="isAuthorHiddenCellTemplate">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'isFingerprintingDisabled'"
                                           :title="$t('registers.forms.gridHeaders.isFingerprintingDisabled')"
                                           :width="150"
                                           :lockable="true"
                                           :locked="false"
                                           :template="isFingerprintingDisabledCellTemplate"
                                           :hidden="true">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'allRecords'"
                                           :title="$t('registers.forms.gridHeaders.allRecords')"
                                           :width="150"
                                           :lockable="true"
                                           :locked="false">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'validRecords'"
                                           :title="$t('registers.forms.gridHeaders.validRecords')"
                                           :width="150"
                                           :lockable="true"
                                           :locked="false">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'deletedRecords'"
                                           :title="$t('registers.forms.gridHeaders.deletedRecords')"
                                           :width="150"
                                           :lockable="true"
                                           :locked="false">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'deactivatedRecords'"
                                           :title="$t('registers.forms.gridHeaders.deactivatedRecords')"
                                           :width="150"
                                           :lockable="true"
                                           :locked="false">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'creatorUsername'"
                                           :title="$t('registers.forms.gridHeaders.creatorUsername')"
                                           :width="150"
                                           :lockable="true"
                                           :locked="false">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'createdAtUtc'"
                                           :title="$t('registers.forms.gridHeaders.createdAtUtc')"
                                           :width="150"
                                           :format="customDateTimeFormat"
                                           :lockable="true"
                                           :locked="false">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'updaterUsername'"
                                           :title="$t('registers.forms.gridHeaders.updaterUsername')"
                                           :width="150"
                                           :lockable="true"
                                           :locked="false">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'updatedAtUtc'"
                                           :title="$t('registers.forms.gridHeaders.updatedAtUtc')"
                                           :width="150"
                                           :format="customDateTimeFormat"
                                           :lockable="true"
                                           :locked="false">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'link'"
                                           :title="$t('registers.forms.formToEvent.gridHeaders.comletionLink')"
                                           :width="450"
                                           :filterable="false"
                                           :sortable="false"
                                           :lockable="true"
                                           :locked="false">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'participationTypesStr'"
                                           :title="$t('registers.forms.formToEvent.gridHeaders.participationTypes')"
                                           :width="250"
                                           :hidden="hasEventId && isEnVersion"
                                           :filterable="false"
                                           :sortable="false"
                                           :lockable="true"
                                           :locked="false">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'participationTypesEnStr'"
                                           :title="$t('registers.forms.formToEvent.gridHeaders.participationTypes')"
                                           :width="250"
                                           :hidden="hasEventId && !isEnVersion"
                                           :filterable="false"
                                           :sortable="false"
                                           :lockable="true"
                                           :locked="false">
                        </kendo-grid-column>

                        <kendo-contextmenu @select="selectContextMenu" :target="'#formsGrid'" :filter="'td'">
                            <li v-if="hasEventDetailsRights" :id="'eventDetailsActive'" class="text-info"><i class="fas fa-eye"></i> {{ $t('buttons.eventDetails.btnText') }}</li>
                        </kendo-contextmenu>
                    </kendo-grid>
                </div>
            </div>
        </div>

        <DetailsModal v-model="relatedRecordsId" :show="showRelatedRecords" @onClose="onDetailsClose"></DetailsModal>
        <IncludeFormCreateModal :eventId="relatedEventId" :show="showIncludeCreate" @onCreate="onIncludeCreate" @onClose="onIncludeCreateClose"></IncludeFormCreateModal>
        <IncludeFormEditModal v-model="formToEventModel" :eventId="relatedEventId" :show="showIncludeEdit" @onEdit="onIncludeEdit" @onClose="onIncludeEditClose"></IncludeFormEditModal>
        <AddLecturersModal v-model="formToEventModel" :show="showAddLecturers" @onAdd="onAddLecturers" @onClose="onAddLecturersClose"></AddLecturersModal>
        <AddParticipantsModal v-model="formToEventModel" :show="showAddParticipants" @onAdd="onAddParticipants" @onClose="onAddParticipantsClose"></AddParticipantsModal>
        <RegisterDetailsModal v-model="eventDetailsModel" :show="showEventDetails" @onClose="onEventDetailsClose"></RegisterDetailsModal>
        <JsonFormatter v-model="summaryDetails" :show.sync="showSummaryDetails"
                       :titleKey="'buttons.summaryData.btnText'"
                       @onClose="onSummaryDetailsClose">
        </JsonFormatter>
    </div>

</template>
<script src="https://kendo.cdn.telerik.com/2019.2.619/js/pako_deflate.min.js"></script>

<script>
    import Vue from 'vue';
    import JSZip from 'jszip'
    import GridUserSettings from '@/components/grid/GridSettingsWrapper';
    import ControlBtnsTemplate from "@/components/dashboard/ControlBtnsTemplate";
    import BtnsTemplate from "@/components/grid/StandardBtnsTemplate";
    import IncludeFormEditModal from '@/components/forms/edit.modal';
    import IncludeFormCreateModal from '@/components/forms/create.modal';
    import AddLecturersModal from '@/components/forms/addLecturers.modal';
    import AddParticipantsModal from '@/components/forms/addParticipants.modal';
    import formSurverService from '@/services/formSurvey.service';
    import DetailsModal from "./details.modal";
    import RegisterDetailsModal from '@/components/dynamic/register/details.modal';
    import JsonFormatter from "@/components/common/json.formatter.modal.vue";
    import { RegisterFieldValueQueryFilter, EventClaims, FormSummaryParticipationStatus, FormSummarySurveyTypeEnum } from '../../models/enums';
    import { Role } from '../../helpers/role';
    import { mapGetters } from 'vuex';

    /*
    Renders the grid in "DejaVu Sans" font family, which is
    declared in kendo.common.css. It also declares the paths to the
    fonts below using <tt>kendo.pdf.defineFont</tt>, because the
    stylesheet is hosted on a different domain.
    */
    kendo.pdf.defineFont({
        "DejaVu Sans": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans.ttf",
        "DejaVu Sans|Bold": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans-Bold.ttf",
        "DejaVu Sans|Bold|Italic": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf",
        "DejaVu Sans|Italic": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf",
        "WebComponentsIcons": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/glyphs/WebComponentsIcons.ttf"
    });

    export default {
        name: 'forms-grid',
        components: {
            'dashboard-ctrl': ControlBtnsTemplate,
            GridUserSettings,
            DetailsModal,
            IncludeFormEditModal,
            IncludeFormCreateModal,
            RegisterDetailsModal,
            JsonFormatter,
            AddLecturersModal,
            AddParticipantsModal
        },
        created: function () {
            window.JSZip = JSZip
        },
        props: {
            showHideButton: {
                default: false,
                type: Boolean
            },
            showPinButton: {
                default: true,
                type: Boolean
            },
            showNewButton: {
                default: true,
                type: Boolean
            },
            showResizeIcon: {
                default: true,
                type: Boolean
            },
            size: {
                default: 6,
                type: Number
            },
            showSettingsBtn: {
                default: true,
                type: Boolean
            },
            showBtns: {
                default: true,
                type: Boolean
            },
            relatedEventId: {
                default: 0,
                type: Number
            },
            showAddButton: {
                default: false,
                type: Boolean
            },
            returnUrl: {
                type: String
            },
            componentName: {
                default: 'FormsListGrid',
                type: String
            },
            showInCard: {
                default: true,
                type: Boolean
            },
            showDashboardCtrls: {
                default: true,
                type: Boolean
            },
            showHeadful: {
                default: true,
                type: Boolean
            },
        },
        data() {
            return {
                showformsGridSettingsForm: false,
                showformsGridSettings: false,
                settingsTooltipText: this.$t('buttons.settings.tooltipText'),
                titleKey: 'registers.forms.title',
                formToEntityId: 0,
                formToEventModel: null,
                showIncludeCreate: false,
                showIncludeEdit: false,
                searchQuery: '',
                relatedRecordsId: 0,
                showRelatedRecords: false,
                showAddLecturers: false,
                showAddParticipants: false,
                schemaModelFields: {
                    id: { name: 'id', type: 'number', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.id' },
                    formId: { name: 'formId', type: 'number', editable: false, nullable: true, visible: false, titleKey: 'registers.forms.gridHeaders.id' },
                    formToRegisterEntityId: { name: 'formToRegisterEntityId', type: 'number', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.id' },
                    registerEntityId: { name: 'registerEntityId', type: 'number', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.id' },
                    eventName: { name: 'eventName', type: 'string', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.eventName' },
                    name: { name: 'name', type: 'string', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.name' },
                    nameEn: { name: 'nameEn', type: 'string', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.nameEn' },
                    formTypeId: { name: 'formTypeId', type: 'number', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.formType' },
                    formType: { name: 'formType', type: 'string', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.formType' },
                    formTypeEn: { name: 'formTypeEn', type: 'string', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.formTypeEn' },
                    validFromUtc: { name: 'validFromUtc', type: 'date', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.validFromUtc' },
                    validToUtc: { name: 'validToUtc', type: 'date', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.validToUtc' },
                    note: { name: 'note', type: 'string', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.note' },
                    isTemplate: { name: 'isTemplate', type: 'boolean', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.isTemplate' },
                    isAnonymous: { name: 'isAnonymous', type: 'boolean', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.isAnonymous' },
                    isAuthorHidden: { name: 'isAuthorHidden', type: 'boolean', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.isAuthorHidden' },
                    isFingerprintingDisabled: { name: 'isFingerprintingDisabled', type: 'boolean', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.isFingerprintingDisabled' },
                    deactivated: { name: 'deactivated', type: 'boolean', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.deactivated' },
                    status: { name: 'status', type: 'string', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.status' },
                    allRecords: { name: 'allRecords', type: 'number', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.allRecords' },
                    validRecords: { name: 'validRecords', type: 'number', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.validRecords' },
                    deletedRecords: { name: 'deletedRecords', type: 'number', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.deletedRecords' },
                    deactivatedRecords: { name: 'deactivatedRecords', type: 'number', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.deactivatedRecords' },
                    creatorUsername: { name: 'creatorUsername', type: 'string', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.creatorUsername' },
                    createdAtUtc: { name: 'createdAtUtc', type: 'date', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.createdAtUtc' },
                    updaterUsername: { name: 'updaterUsername', type: 'string', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.updaterUsername' },
                    updatedAtUtc: { name: 'createdAtUtc', type: 'date', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.updatedAtUtc' },
                    link: { name: 'link', type: 'string', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.formToEvent.gridHeaders.comletionLink' },
                    participationTypes: { name: 'participationTypes', type: 'array', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.formToEvent.gridHeaders.comletionLink' },
                    participationTypesStr: { name: 'participationTypesStr', type: 'string', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.formToEvent.gridHeaders.comletionLink' },
                    participationTypesEnStr: { name: 'participationTypesEnStr', type: 'string', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.formToEvent.gridHeaders.comletionLink' },

                },
                formToEventFields: {
                    id: { name: 'id', from: 'id', type: 'number', nullable: false },
                    name: { name: 'name', from: 'name', type: 'string', nullable: false },
                    nameEn: { name: 'name', from: 'name', type: 'string', nullable: true },
                    type: { name: 'name', from: 'name', type: 'string', nullable: true },
                    typeEn: { name: 'name', from: 'name', type: 'string', nullable: true }
                },
                transportSettings: {
                    read: {
                        url: this.$store.getters.baseUrl + '/api/dynamicForms/' + (this.relatedEventId ? 'listForEvent' : 'listFormsByCondition'),
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.parameterMap
                },
                gridOptions: {
                    ...this.$store.getters.gridOptions,
                    excel: {
                        fileName: 'Forms.xlsx',
                        allPages: false,
                        filterable: true,
                        collapsible: true
                    },
                    pdf: {
                        fileName: 'Forms.pdf',
                        title: this.$t(this.titleKey),
                        subject: this.$t(this.titleKey),
                        creator: this.$store.userName,
                        allPages: false,
                        avoidLinks: true,
                        paperSize: 'A4',
                        margin: { top: '2cm', left: '1cm', right: '1cm', bottom: '1cm' },
                        landscape: true,
                        repeatHeaders: true,
                        scale: 0.6
                    }
                },
                working: false,
                formsFilter: 2,
                formsFilterItems: [{ id: 0, text: this.$t('formsFilterSource.all') }, { id: 1, text: this.$t('formsFilterSource.templates') }, { id: 2, text: this.$t('formsFilterSource.notTamplates') }],
                eventDetailsFilterEnum: RegisterFieldValueQueryFilter.Active,
                eventDetailsModel: null,
                showEventDetails: false,
                excludedFromFilterColumns: ['participationTypesStr', 'participationTypesEnStr'], //Properties of the model that has been missing in the DTO model Thus search can not be made from the Dynamic sql library.
                summaryDetails: '',
                showSummaryDetails: false
            }
        },
        methods: {
            dataBound(e) {
                if (e.sender.options.dataSourceRef == 'datasource1'
                    && this.showSettingsBtn
                    && !this.showformsGridSettings) {
                    this.showformsGridSettings = true;
                }

                var items = e.sender.items();
                items.each(function (idx, item) {
                    let dataItem = e.sender.dataItem(item);
                    if (dataItem.status === 'Active') {
                        $(item).addClass('left-border-green');
                    } else if (dataItem.status === 'Passed') {
                        $(item).addClass('left-border-danger');
                    } else if (dataItem.status === 'Upcoming') {
                        $(item).addClass('left-border-blue');
                    }
                });
            },
            dataSourceError(e) {
                this.$vs.notify({
                    title: this.$t('notifications.error'),
                    text: this.$helpers.kendoDataSourceErrorText(e),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration,
                });
            },
            parameterMap: function (options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) }
                } else {
                    let newOptions = { eventId: this.relatedEventId, formsFilter: this.formsFilter, request: options };
                    return kendo.stringify(newOptions);
                }
            },
            beforeSend: function (req) {
                if (this.token) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.token);
                }
            },
            changeGridSettings() {
                this.showformsGridSettingsForm = !this.showformsGridSettingsForm;
            },
            resize(componentName, size) {
                this.$emit('resize', componentName, size, this.$refs.formsGrid.kendoWidget())
            },
            hide(componentName) {
                this.$emit('hide', componentName)
            },
            pinned(componentName) {
                this.$emit('pinned', componentName)
            },
            unpinned(componentName) {
                this.$emit('unpinned', componentName)
            },
            datasorceRequestEnd(e) {
                if (e.type == "read" && e.response) {

                }
            },
            formToEventDeactivatedCellTemplate: function (dataItem) {
                let templateHtml =
                    '<span class="badge ' + (dataItem.deactivated ? 'badge-secondary' : 'badge-success') + '">' + kendo.htmlEncode(dataItem.deactivated ? this.$t('no') : this.$t('yes')) + '</span>';

                return templateHtml;
            },
            deactivatedTemplateCellTemplate: function (dataItem) {
                let templateHtml =
                    '<span class="badge ' + (dataItem.deactivated ? 'badge-danger' : 'badge-success') + '">' + kendo.htmlEncode(dataItem.deactivated ? this.$t('yes') : this.$t('no')) + '</span>';

                return templateHtml;
            },
            isTemplateCellTemplate: function (dataItem) {
                let templateHtml =
                    '<span class="badge ' + (dataItem.isTemplate ? 'badge-success' : 'badge-secondary') + '">' + kendo.htmlEncode(dataItem.isTemplate ? this.$t('yes') : this.$t('no')) + '</span>';

                return templateHtml;
            },
            statusCellTemplate: function (dataItem) {
                let templateHtml =
                    '<span class="badge ' + (dataItem.status.indexOf('Active') >= 0 ? 'badge-success' : (dataItem.status.indexOf('Passed') >= 0 ? 'badge-warning' : 'badge-info')) + '">' + kendo.htmlEncode(dataItem.status) + '</span>';

                return templateHtml;
            },
            isAnonymousCellTemplate: function (dataItem) {
                let templateHtml =
                '<span class="badge ' + (dataItem.isAnonymous ? 'badge-warning' : 'badge-secondary') + '">' + kendo.htmlEncode(dataItem.isAnonymous ? this.$t('yes') : this.$t('no')) + '</span>';

                return templateHtml;
            },
            isAuthorHiddenCellTemplate: function (dataItem) {
                let templateHtml =
                '<span class="badge ' + (dataItem.isAuthorHidden ? 'badge-warning' : 'badge-secondary') + '">' + kendo.htmlEncode(dataItem.isAuthorHidden ? this.$t('yes') : this.$t('no')) + '</span>';

                return templateHtml;
            },
            isFingerprintingDisabledCellTemplate: function (dataItem) {
                let templateHtml =
                '<span class="badge ' + (dataItem.isFingerprintingDisabled ? 'badge-warning' : 'badge-secondary') + '">' + kendo.htmlEncode(dataItem.isFingerprintingDisabled ? this.$t('yes') : this.$t('no')) + '</span>';

                return templateHtml;
            },
            addFormToEvent() {
                if (!this.showAddButton || !this.eventClaims['EVENTFORMMANAGEMENT'].create) {
                    return this.$router.push(`/unauthorized`);
                }

                this.showIncludeCreate = true;
            },
            editTimeRanges(args) {
                if (!args.formToRegisterEntityId || !this.eventClaims[EventClaims.EventFormManagement].update) {
                    return this.$router.push(`/unauthorized`);
                }

                this.formToEventModel = {
                    ... {
                        id: args.formToRegisterEntityId,
                        eventId: this.hasEventId ? this.relatedEventId : args.registerEntityId,
                        formId: args.formId,
                        formType: args.formType,
                        formTypeEn: args.formTypeEn,
                        name: args.name,
                        eventName: args.eventName,
                        startTime: args.validFromUtc,
                        endTime: args.validToUtc,
                        deactivated: args.deactivated,
                        isTemplate: args.isTemplate,
                        participationTypes: args.participationTypes,
                        isAnonymous: args.isAnonymous,
                        isAuthorHidden: args.isAuthorHidden,
                        isFingerprintingDisabled: args.isFingerprintingDisabled,
                        validRecords: args.validRecords
                    }
                }
                this.showIncludeEdit = true;
            },
            addLecturers(args) {
                if (!args.formToRegisterEntityId || !this.eventClaims[EventClaims.EventFormManagement].update) {
                    return this.$router.push(`/unauthorized`);
                }

                this.formToEventModel = {
                    ... {
                        id: args.formToRegisterEntityId,
                        eventId: this.hasEventId ? this.relatedEventId : args.registerEntityId,
                        formId: args.formId,
                        formType: args.formType,
                        formTypeEn: args.formTypeEn,
                        name: args.name,
                        eventName: args.eventName,
                        startTime: args.validFromUtc,
                        endTime: args.validToUtc,
                        deactivated: args.deactivated,
                        isTemplate: args.isTemplate,
                        participationTypes: args.participationTypes,
                        isAnonymous: args.isAnonymous,
                        isAuthorHidden: args.isAuthorHidden,
                        isFingerprintingDisabled: args.isFingerprintingDisabled
                    }
                }
                this.showAddLecturers = true;
            },
            addParticipants(args) {
                if (!args.formToRegisterEntityId || !this.eventClaims[EventClaims.EventFormManagement].update) {
                    return this.$router.push(`/unauthorized`);
                }

                this.formToEventModel = {
                    ... {
                        id: args.formToRegisterEntityId,
                        eventId: this.hasEventId ? this.relatedEventId : args.registerEntityId,
                        formId: args.formId,
                        formType: args.formType,
                        formTypeEn: args.formTypeEn,
                        name: args.name,
                        eventName: args.eventName,
                        startTime: args.validFromUtc,
                        endTime: args.validToUtc,
                        deactivated: args.deactivated,
                        isTemplate: args.isTemplate,
                        participationTypes: args.participationTypes,
                        isAnonymous: args.isAnonymous,
                        isAuthorHidden: args.isAuthorHidden,
                        isFingerprintingDisabled: args.isFingerprintingDisabled,
                    }
                }
                this.showAddParticipants = true;
            },
            createBtnClick() {
                if (!this.hasFormCreateRights) {
                    return this.$router.push(`/unauthorized`);
                }

                let routeData = this.$router.resolve({ name: 'createForm', query: { relatedId: this.relatedEventId, returnUrl: this.returnUrl } });
                window.open(routeData.href, '_blank');
            },
            editBtnClick(args) {
                if (!this.hasFormEditRights) {
                    return this.$router.push(`/unauthorized`);
                }

                let routeData = this.$router.resolve({ name: 'editForm', query: { id: args.formId, returnUrl: this.returnUrl } });
                window.open(routeData.href, '_blank');
            },
            detailsBtnClick: function (args) {
                if (!this.hasFormDetailsRights) {
                    return this.$router.push(`/unauthorized`);
                }

                let routeData = this.$router.resolve({ name: 'formDetails', query: { id: args.formId, returnUrl: this.returnUrl } });
                window.open(routeData.href, '_blank');
            },
            eventEditBtnClick(args) {
                let routeData = this.$router.resolve({ name: 'eventsEdit', params: { id: args.registerEntityId } })
                window.open(routeData.href, '_blank')
            },
            eventDetailsBtnClick(args) {
                this.showEventDetailsModal({ registerEntityId: args.registerEntityId }, this.eventDetailsFilterEnum)
            },
            copyBtnClick(args) {
                if (!this.hasCopyRights) {
                    return this.$router.push(`/unauthorized`);
                }

                let routeData = this.$router.resolve({ name: 'copyForm', query: { id: args.formId, returnUrl: this.returnUrl } });
                window.open(routeData.href, '_blank');
            },
            relatedRecordsClick: function (args) {
                if (!this.hasFormSummaryRights) {
                    this.$router.push(`/unauthorized`);
                } else {
                    this.showRelatedRecordsModal(args.formToRegisterEntityId);
                }
            },
            summaryRecordsClick(args) {
                if (!this.hasFormSummaryRights) {
                    this.$router.push(`/unauthorized`);
                } else {
                    this.$vs.loading({
                        progress: 0,
                        text: `${this.$t('buttons.summaryDataReview.btnText')}...`
                    })

                    this.$http.get(`/api/formSummary/model`, { params: { formId: args.formId, eventId: args.registerEntityId }})
                        .then(response => {
                            this.summaryDetails = response.data;
                            this.showSummaryDetails = true;
                        }).catch(error => {
                            this.$vs.notify({
                                title: this.$t('buttons.summaryDataReview.btnText'),
                                text: this.$helpers.errorText(error),
                                color: 'error',
                                time: this.$store.getters.notificationDuration,
                            })
                        }).then(() => {
                            this.$vs.loading.close();
                        });
                }
            },
            summaryRecordsPdfReportClick(args) {
                this.summaryRecordsReportClick(args, 'pdf');
            },
            summaryRecordsWordReportClick(args) {
                this.summaryRecordsReportClick(args, 'docx');
            },
            summaryRecordsReportClick(args, fileType) {
                if (!this.hasFormSummaryRights) {
                    return this.$router.push(`/unauthorized`);
                }

                this.$vs.loading({
                    progress: 0,
                    text: `${this.$t('buttons.summaryDataReport.btnText')}...`
                })

                this.$http
                    .get("/api/formSummary/createReport", {
                        params: { formId: args.formId, eventId: args.registerEntityId, fileType },
                        responseType: "blob",
                    })
                    .then((response) => {
                        const blob = new Blob([response.data], {
                            type: fileType.type === 'pdf' ? "application/pdf" : 'application/msword',
                        });
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement("a");
                        link.href = url;
                        link.setAttribute(
                            "download",
                            `Summary_EventId_${args.registerEntityId}_FormId_${args.formId}.${fileType}`
                        ); // or any other extension
                        document.body.appendChild(link);
                        link.click();
                    })
                    .catch((error) => {
                        this.$vs.notify({
                            title: this.$t('buttons.summaryDataReport.btnText'),
                            text: this.$helpers.errorText(error),
                            color: "danger",
                            time: this.$store.getters.notificationDuration,
                        });
                    }).then(() => {
                        this.$vs.loading.close();
                    });
            },
            summaryRecordsWordReportClick_new(args, participationStatusType, formSummarySurveyType) {
                if (!this.hasFormSummaryRights) {
                    return this.$router.push(`/unauthorized`);
                }

                this.$vs.loading({
                    progress: 0,
                    text: `${this.$t('buttons.summaryDataReport.btnText')}...`
                })

                this.$http
                    .get("/api/formSummary/createReport_new", {
                        params: { formId: args.formId, eventId: args.registerEntityId, participationStatusType: participationStatusType, formSummarySurveyType: formSummarySurveyType},
                        responseType: 'blob',
                    })
                    .then((response) => {
                        const fileName =  `Sumary_EventId_${args.registerEntityId}_FormId_${args.formId}.docx`;
                        const contentType = 'application/octet-stream';
                        const href = window.URL.createObjectURL(new Blob([response.data], { type: contentType }));
                        const link = document.createElement('a');
                        link.href = href;
                        link.setAttribute('download', fileName);
                        document.body.appendChild(link);
                        link.click();
                    })
                    .catch((error) => {
                        this.$vs.notify({
                            title: this.$t('buttons.summaryDataReport.btnText'),
                            text: this.$helpers.errorText(error),
                            color: "danger",
                            time: this.$store.getters.notificationDuration,
                        });
                    }).then(() => {
                        this.$vs.loading.close();
                    });
            },
            onSummaryDetailsClose() {
                this.summaryDetails = '';
                this.showSummaryDetails = false;
            },
            deleteFormToEventEntity(args) {
                if (!this.hasDeleteRights) {
                    this.$router.push(`/unauthorized`);
                    return;
                }

                kendo.confirm(`${this.$t('registers.forms.confirmations.deleteLinkedForm')}`)
                    .then(function () {
                        this.doDelete(this.hasEventId ? args.id : args.formToRegisterEntityId,
                            this.hasEventId ? args.relatedEventId : args.registerEntityId);
                    }.bind(this));
            },
            doDelete(id, eventId) {
                this.working = true;
                formSurverService
                    .deleteFormToEventEntity(id, eventId)
                    .then(response => {
                        this.refresh()

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.responseStatusCode(response)),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration
                        });

                    })
                    .catch(error => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    }).then(() => { this.working = false; });
            },
            deleteFormWithFormToEventEntity(args) {
                if (!this.hasDeleteRights) {
                    this.$router.push(`/unauthorized`);
                    return;
                }

                kendo.confirm(`${this.$t('registers.forms.confirmations.deleteLinkedFormWithForm')}`)
                    .then(function () {
                        this.doDeleteWithForm(this.hasEventId ? args.id : args.formToRegisterEntityId,
                            this.hasEventId ? args.relatedEventId : args.registerEntityId);
                    }.bind(this));
            },
            doDeleteWithForm(id, eventId) {
                this.working = true;
                formSurverService
                    .deleteFormWithFormToEventEntity(id, eventId)
                    .then(response => {
                        this.refresh()

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.responseStatusCode(response)),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration
                        });

                    })
                    .catch(error => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    }).then(() => { this.working = false; });
            },
            softDeleteForm(args) {
                kendo.confirm(`${this.$t('buttons.delete.confirmationText')}`)
                    .then(function () {
                        this.doSoftDeleteForm(args.formId);
                    }.bind(this));
            },
            realDeleteForm(args) {
                kendo.confirm(`${this.$t('buttons.delete.confirmationText')}`)
                    .then(function () {
                        this.doRealDeleteForm(args.formId);
                    }.bind(this));
            },
            doSoftDeleteForm(id) {
                this.working = true;
                formSurverService
                    .deleteForm(id)
                    .then(response => {
                        this.refresh()

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.responseStatusCode(response)),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration
                        });

                    })
                    .catch(error => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    }).then(() => { this.working = false; });
            },
            doRealDeleteForm(id) {
                this.working = true;
                formSurverService
                    .realDeleteForm(id)
                    .then(response => {
                        this.refresh()

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.responseStatusCode(response)),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration
                        });

                    })
                    .catch(error => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    }).then(() => { this.working = false; });
            },
            deleteFormWithRelatedRecords(args) {
                if (!this.userRoles.includes(Role.SuperAdmin)) {
                    this.$router.push(`/unauthorized`);
                    return;
                }

                kendo.confirm(`${this.$t('registers.forms.confirmations.deleteFormWithRelatedRecords')}`)
                    .then(function () {
                        this.doDeleteFormWithRelatedRecords(args.formToRegisterEntityId,this.relatedEventId);
                    }.bind(this));
            },
            doDeleteFormWithRelatedRecords(id, eventId) {
                this.working = true;
                formSurverService
                    .deleteFormWithRelatedRecords(id, eventId)
                    .then(response => {
                        this.refresh()

                        this.$vs.notify({
                            title: this.$t('buttons.deleteFormWithRelatedRecords.btnText'),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration
                        });

                    })
                    .catch(error => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    }).then(() => { this.working = false; });
            },
            actiavateFormToEventEntity(args) {
                if (!this.hasActivateDeactivateRights) {
                    this.$router.push(`/unauthorized`);
                    return;
                }

                if (!args.deactivated) {
                    this.$vs.notify({
                        title: this.$t('buttons.activate.action'),
                        text: this.$t('buttons.activate.already'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration,
                    })

                    return;
                }

                this.working = true;
                formSurverService
                    .actiavateFormToEventEntity(this.hasEventId ? args.id : args.formToRegisterEntityId,
                        this.hasEventId ? args.relatedEventId : args.registerEntityId)
                    .then(response => {
                        this.refresh()

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.responseStatusCode(response)),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration
                        });
                    })
                    .catch(error => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    }).then(() => { this.working = false; });
            },
            deactivateFormToEventEntity(args) {
                if (!this.hasActivateDeactivateRights) {
                    this.$router.push(`/unauthorized`);
                    return;
                }

                if (args.deactivated) {
                    this.$vs.notify({
                        title: this.$t('buttons.deactivate.action'),
                        text: this.$t('buttons.deactivate.already'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration,
                    })

                    return;
                }

                this.working = true;
                formSurverService
                    .deactivateFormToEventEntity(this.hasEventId ? args.id : args.formToRegisterEntityId,
                        this.hasEventId ? args.relatedEventId : args.registerEntityId)
                    .then(response => {
                        this.refresh()

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.responseStatusCode(response)),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration
                        });
                    })
                    .catch(error => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    }).then(() => { this.working = false; });
            },
            refresh() {
                const grid = this.$refs.formsGrid.kendoWidget();
                if (grid) {
                    grid.dataSource.read();
                }
            },
            showRelatedRecordsModal(id) {
                this.relatedRecordsId = id;
                this.showRelatedRecords = true;
            },
            onDetailsClose() {
                this.showRelatedRecords = false;
                this.relatedRecordsId = 0;
            },
            clearFilters() {
                this.searchQuery = '';
                const grid = this.$refs.formsGrid.kendoWidget();
                if (grid) {
                    grid.dataSource.sort({});
                    grid.dataSource.page(1);
                    grid.dataSource.aggregate([]);
                    grid.dataSource.filter({});
                }
            },
            massSearch() {
                if (!this.searchQuery) {
                    this.$vs.notify({
                        title: this.$t('buttons.search.btnText'),
                        text: this.$t('emptySearchFilter'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration
                    })

                    return;
                }

                let grid = this.$refs.formsGrid.kendoWidget();
                if (grid) {
                    let filter = this.$helpers.getMassFilterForGrid(grid, this.searchQuery, this.excludedFromFilterColumns);
                    if (filter) {
                        grid.dataSource.filter(filter);
                    }
                }
            },
            onIncludeCreateClose() {
                this.showIncludeCreate = false;
                this.formToEntityId = 0;
            },
            onIncludeEditClose() {
                this.showIncludeEdit = false;
                this.formToEntityId = 0;
                this.formToEventModel = null;
            },
            onIncludeCreate(model) {
                this.$emit("formCreate", model);
                this.formToEntityId = 0;
                this.refresh();

            },
            onIncludeEdit(model) {
                this.$emit("formEdit", model);
                this.formToEntityId = 0;
                this.formToEventModel = null;
                this.refresh();
            },
            onAddLecturersClose() {
                this.showAddLecturers = false;
                this.formToEntityId = 0;
                this.formToEventModel = null;
            },
            onAddLecturers(model) {
                this.formToEntityId = 0;
                this.formToEventModel = null;
                this.refresh();
            },
            onAddParticipantsClose() {
                this.showAddParticipants = false;
                this.formToEntityId = 0;
                this.formToEventModel = null;
            },
            onAddParticipants(model) {
                this.formToEntityId = 0;
                this.formToEventModel = null;
                this.refresh();
            },
            selectContextMenu(e) {
                var btnId = e.item.id;
                var index = e.target.parentElement.rowIndex;
                var row = this.$refs.formsGrid.kendoWidget().dataSource.data()[index]
                if (!row) {
                    return;
                }

                if (btnId === 'eventDetailsActive') {
                    if (row.registerEntityId) {
                        this.showEventDetailsModal({ registerEntityId: row.registerEntityId }, this.eventDetailsFilterEnum)
                    }
                }
            },
            showEventDetailsModal(args, filter) {
                this.$api.dynamicRegister
                    .getDetails(args.registerEntityId, filter)
                    .then(response => {
                        const model = response.data;
                        if (model) {
                            this.eventDetailsModel = model;
                            this.showEventDetails = true;
                        }
                    })
                    .catch(error => {
                        this.eventDetailsModel = null;
                        this.showEventDetails = false;

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            onEventDetailsClose() {
                this.showEventDetails = false;
                this.eventDetailsModel = null;
            },
            btnsTemplate: function (e) {
                return {
                    template: Vue.component(BtnsTemplate.name, BtnsTemplate),
                    templateArgs: {
                        ...e,
                        parentComponent: this.$refs.formsGrid,
                        btns: this.hasEventId
                            ?
                            [
                                {
                                    name: "timeRangeEdit",
                                    text: this.$t('buttons.timeRangeEdit.btnText'),
                                    tooltip: this.$t('buttons.timeRangeEdit.btnText'),
                                    class: 'btn btn-primary',
                                    icon: "fas fa-clock",
                                    show: e.formToRegisterEntityId && this.eventClaims[EventClaims.EventFormManagement].update,
                                    clickHandler: this.editTimeRanges
                                },
                                {
                                    name: "addLecturers",
                                    text: this.$t('buttons.addLecturers.btnText'),
                                    tooltip: this.$t('buttons.addLecturers.btnText'),
                                    class: 'btn btn-primary',
                                    icon: "fas fa-university",
                                    show: e.formToRegisterEntityId && this.eventClaims[EventClaims.EventFormManagement].update,
                                    clickHandler: this.addLecturers
                                },
                                {
                                    name: "addParticipants",
                                    text: this.$t('buttons.addParticipant.btnText'),
                                    tooltip: this.$t('buttons.addParticipant.btnText'),
                                    class: 'btn btn-primary',
                                    icon: "fas fa-user-plus",
                                    show: e.formToRegisterEntityId && this.eventClaims[EventClaims.EventFormManagement].update,
                                    clickHandler: this.addParticipants
                                },
                                {
                                    name: "formEdit",
                                    text: this.$t('buttons.formEdit.btnText'),
                                    tooltip: this.$t('buttons.formEdit.btnText'),
                                    class: 'btn btn-primary',
                                    icon: "fas fa-edit",
                                    show: e.formId,
                                    clickHandler: this.editBtnClick
                                },
                                {
                                    name: "formDetails",
                                    text: this.$t('buttons.formDetails.btnText'),
                                    tooltip: this.$t('buttons.formDetails.btnText'),
                                    class: 'btn btn-primary',
                                    icon: "fas fa-info-circle",
                                    show: e.formId,
                                    clickHandler: this.detailsBtnClick
                                },
                                {
                                    name: "relatedRecords",
                                    text: this.$t('buttons.dataReview.btnText'),
                                    tooltip: this.$t('buttons.dataReview.btnText'),
                                    class: 'btn btn-primary',
                                    icon: "fas fa-table",
                                    show: e.formToRegisterEntityId,
                                    clickHandler: this.relatedRecordsClick
                                },
                                {
                                    name: "summarizedRecords",
                                    text: this.$t('buttons.summaryDataReview.btnText'),
                                    tooltip: this.$t('buttons.summaryDataReview.btnText'),
                                    class: 'btn btn-primary',
                                    icon: "fas fa-table",
                                    show: e.formToRegisterEntityId,
                                    clickHandler: this.summaryRecordsClick
                                },
                                {
                                    name: "summarizedRecordsReportPdf",
                                    text: this.$t('buttons.summaryDataReport.btnText') + ' (pdf)',
                                    tooltip: this.$t('buttons.summaryDataReport.btnText') + '(pdf)',
                                    class: 'btn btn-danger',
                                    icon: "far fa-file-pdf",
                                    show: e.formToRegisterEntityId,
                                    clickHandler: this.summaryRecordsPdfReportClick
                                },
                                {
                                    name: "summarizedRecordsReportDocx",
                                    text: this.$t('buttons.summaryDataReport.btnText') + ' (docx)',
                                    tooltip: this.$t('buttons.summaryDataReport.btnText') + ' (docx)',
                                    class: 'btn btn-info',
                                    icon: "far fa-file-word",
                                    show: e.formToRegisterEntityId,
                                    clickHandler: this.summaryRecordsWordReportClick
                                },
                                {
                                    name: "summarizedRecordsReportDocx",
                                    text: this.$t('buttons.summaryDataReportNew.btnText') + ' (docx)',
                                    tooltip: this.$t('buttons.summaryDataReportNew.btnText') + ' (docx)',
                                    class: 'btn btn-info',
                                    icon: "far fa-file-word",
                                    show: e.formToRegisterEntityId,
                                    clickHandler: (args) => this.summaryRecordsWordReportClick_new(args, FormSummaryParticipationStatus.GraduatedParticipants, FormSummarySurveyTypeEnum.NonAnonymous)
                                },
                                {
                                    name: "summarizedRecordsReportDocx",
                                    text: this.$t('buttons.summaryDataReportNewAnonymous.btnText') + ' (docx)',
                                    tooltip: this.$t('buttons.summaryDataReportNewAnonymous.btnText') + ' (docx)',
                                    class: 'btn btn-info',
                                    icon: "far fa-file-word",
                                    show: e.formToRegisterEntityId,
                                    clickHandler: (args) => this.summaryRecordsWordReportClick_new(e, FormSummaryParticipationStatus.All, FormSummarySurveyTypeEnum.Anonymous)
                                },
                                {
                                    name: "summarizedRecordsReportDocx",
                                    text: this.$t('buttons.summaryDataReportNewAll.btnText') + ' (docx)',
                                    tooltip: this.$t('buttons.summaryDataReportNewAll.btnText') + ' (docx)',
                                    class: 'btn btn-info',
                                    icon: "far fa-file-word",
                                    show: e.formToRegisterEntityId,
                                    clickHandler: (args) => this.summaryRecordsWordReportClick_new(e, FormSummaryParticipationStatus.All, FormSummarySurveyTypeEnum.All)
                                },
                                {
                                    name: "deleteFormToEventEntity",
                                    text: this.$t('buttons.delete.btnText'),
                                    tooltip: this.$t('buttons.delete.btnText'),
                                    class: 'btn btn-danger',
                                    icon: "fas fa-trash-alt",
                                    show: e.formToRegisterEntityId,
                                    clickHandler: this.deleteFormToEventEntity
                                },
                                {
                                    name: "deleteFormWithFormToEventEntity",
                                    text: this.$t('buttons.deleteWithForm.btnText'),
                                    tooltip: this.$t('buttons.deleteWithForm.btnText'),
                                    class: 'btn btn-danger',
                                    icon: "fas fa-exclamation-triangle",
                                    show: e.formToRegisterEntityId && e.formId,
                                    clickHandler: this.deleteFormWithFormToEventEntity
                                },
                                {
                                    name: "deleteFormWithRelatedRecords",
                                    text: this.$t('buttons.deleteFormWithRelatedRecords.btnText'),
                                    tooltip: this.$t('buttons.deleteFormWithRelatedRecords.btnText'),
                                    class: 'btn btn-danger',
                                    icon: "fas fa-radiation-alt",
                                    show: e.formToRegisterEntityId && this.userRoles.includes(Role.SuperAdmin),
                                    clickHandler: this.deleteFormWithRelatedRecords
                                },
                                {
                                    name: "actiavteFormToEventEntity",
                                    text: this.$t('buttons.formCompleteActivate.btnText'),
                                    tooltip: this.$t('buttons.formCompleteActivate.btnText'),
                                    class: 'btn btn-danger',
                                    icon: "fas fa-lock-open",
                                    show: e.formToRegisterEntityId && e.status !== 'Active' && e.deactivated,
                                    clickHandler: this.actiavateFormToEventEntity
                                },
                                {
                                    name: "deactivateFormToEventEntity",
                                    text: this.$t('buttons.formCompleteDeactivate.btnText'),
                                    tooltip: this.$t('buttons.formCompleteDeactivate.btnText'),
                                    class: 'btn btn-danger',
                                    icon: "fas fa-lock",
                                    show: e.formToRegisterEntityId && !e.deactivated,
                                    clickHandler: this.deactivateFormToEventEntity
                                },
                                {
                                    name: 'copy',
                                    text: this.$t('buttons.copy.btnText'),
                                    tooltip: this.$t('buttons.copy.btnText'),
                                    class: 'btn btn-primary',
                                    icon: 'fas fa-copy',
                                    show: e.formId,
                                    clickHandler: this.copyBtnClick
                                }
                            ]
                            :
                            [
                                {
                                    name: "formEdit",
                                    text: this.$t('buttons.formEdit.btnText'),
                                    tooltip: this.$t('buttons.formEdit.btnText'),
                                    class: 'btn btn-primary',
                                    icon: "fas fa-edit",
                                    show: e.formId,
                                    clickHandler: this.editBtnClick
                                },
                                {
                                    name: "formDetails",
                                    text: this.$t('buttons.formDetails.btnText'),
                                    tooltip: this.$t('buttons.formDetails.btnText'),
                                    class: 'btn btn-primary',
                                    icon: "fas fa-info-circle",
                                    show: e.formId,
                                    clickHandler: this.detailsBtnClick
                                },
                                {
                                    name: "eventEdit",
                                    text: this.$t('buttons.eventEdit.btnText'),
                                    tooltip: this.$t('buttons.eventEdit.btnText'),
                                    class: 'btn btn-primary',
                                    icon: "fas fa-edit",
                                    show: e.registerEntityId,
                                    clickHandler: this.eventEditBtnClick
                                },
                                {
                                    name: "eventDetails",
                                    text: this.$t('buttons.eventDetails.btnText'),
                                    tooltip: this.$t('buttons.eventDetails.btnText'),
                                    class: 'btn btn-primary',
                                    icon: "fas fa-info-circle",
                                    show: e.registerEntityId,
                                    clickHandler: this.eventDetailsBtnClick
                                },
                                {
                                    name: "relatedRecords",
                                    text: this.$t('buttons.dataReview.btnText'),
                                    tooltip: this.$t('buttons.dataReview.btnText'),
                                    class: 'btn btn-primary',
                                    icon: "fas fa-table",
                                    show: e.formToRegisterEntityId,
                                    clickHandler: this.relatedRecordsClick
                                },
                                {
                                    name: "summarizedRecords",
                                    text: this.$t('buttons.summaryDataReview.btnText'),
                                    tooltip: this.$t('buttons.summaryDataReview.btnText'),
                                    class: 'btn btn-primary',
                                    icon: "fas fa-table",
                                    show: e.formToRegisterEntityId,
                                    clickHandler: this.summaryRecordsClick
                                },
                                {
                                    name: "summarizedRecordsReportPdf",
                                    text: this.$t('buttons.summaryDataReport.btnText') + ' (pdf)',
                                    tooltip: this.$t('buttons.summaryDataReport.btnText') + ' (pdf)',
                                    class: 'btn btn-danger',
                                    icon: "far fa-file-pdf",
                                    show: e.formToRegisterEntityId,
                                    clickHandler: this.summaryRecordsPdfReportClick
                                },
                                {
                                    name: "summarizedRecordsReportDocx",
                                    text: this.$t('buttons.summaryDataReport.btnText') + ' (docx)',
                                    tooltip: this.$t('buttons.summaryDataReport.btnText') + ' (docx)',
                                    class: 'btn btn-info',
                                    icon: "far fa-file-word",
                                    show: e.formToRegisterEntityId,
                                    clickHandler: this.summaryRecordsWordReportClick
                                },
                                {
                                    name: "summarizedRecordsReportDocx",
                                    text: this.$t('buttons.summaryDataReportNew.btnText') + ' (docx)',
                                    tooltip: this.$t('buttons.summaryDataReportNew.btnText') + ' (docx)',
                                    class: 'btn btn-info',
                                    icon: "far fa-file-word",
                                    show: e.formToRegisterEntityId,
                                    clickHandler: this.summaryRecordsWordReportClick_new
                                },
                                {
                                    name: "summarizedRecordsReportDocx",
                                    text: this.$t('buttons.summaryDataReportNew.btnText') + ' (docx)',
                                    tooltip: this.$t('buttons.summaryDataReportNew.btnText') + ' (docx)',
                                    class: 'btn btn-info',
                                    icon: "far fa-file-word",
                                    show: e.formToRegisterEntityId,
                                    clickHandler: this.summaryRecordsWordReportClick_new
                                },
                                {
                                    name: "softDeleteForm",
                                    text: this.$t('buttons.softDelete.btnText'),
                                    tooltip: this.$t('buttons.softDelete.btnText'),
                                    class: 'btn btn-danger',
                                    icon: "fas fa-trash-alt",
                                    show: e.formId && !e.formToRegisterEntityId,
                                    clickHandler: this.softDeleteForm
                                },
                                {
                                    name: "realDeleteForm",
                                    text: this.$t('buttons.realDelete.btnText'),
                                    tooltip: this.$t('buttons.realDelete.btnText'),
                                    class: 'btn btn-danger',
                                    icon: "fas fa-trash-alt",
                                    show: e.formId && !e.formToRegisterEntityId,
                                    clickHandler: this.realDeleteForm
                                },
                                {
                                    name: "deleteFormToEventEntity",
                                    text: this.$t('buttons.delete.btnText'),
                                    tooltip: this.$t('buttons.delete.btnText'),
                                    class: 'btn btn-danger',
                                    icon: "fas fa-trash-alt",
                                    show: e.formToRegisterEntityId,
                                    clickHandler: this.deleteFormToEventEntity
                                },
                                {
                                    name: "deleteFormWithFormToEventEntity",
                                    text: this.$t('buttons.deleteWithForm.btnText'),
                                    tooltip: this.$t('buttons.deleteWithForm.btnText'),
                                    class: 'btn btn-danger',
                                    icon: "fas fa-exclamation-triangle",
                                    show: e.formToRegisterEntityId && e.formId,
                                    clickHandler: this.deleteFormWithFormToEventEntity
                                },
                                {
                                    name: "actiavteFormToEventEntity",
                                    text: this.$t('buttons.formCompleteActivate.btnText'),
                                    tooltip: this.$t('buttons.formCompleteActivate.btnText'),
                                    class: 'btn btn-danger',
                                    icon: "fas fa-lock-open",
                                    show: e.formToRegisterEntityId && e.status !== 'Active' && e.deactivated,
                                    clickHandler: this.actiavateFormToEventEntity
                                },
                                {
                                    name: "deactivateFormToEventEntity",
                                    text: this.$t('buttons.formCompleteDeactivate.btnText'),
                                    tooltip: this.$t('buttons.formCompleteDeactivate.btnText'),
                                    class: 'btn btn-danger',
                                    icon: "fas fa-lock",
                                    show: e.formToRegisterEntityId && !e.deactivated,
                                    clickHandler: this.deactivateFormToEventEntity
                                },
                                {
                                    name: 'copy',
                                    text: this.$t('buttons.copy.btnText'),
                                    tooltip: this.$t('buttons.copy.btnText'),
                                    class: 'btn btn-primary',
                                    icon: 'fas fa-copy',
                                    show: e.formId,
                                    clickHandler: this.copyBtnClick
                                }
                            ]
                    }
                };
            },
        },
        computed: {
            ...mapGetters(['dateFormat', 'dateTimeFormat', 'dateTimeLongFormat', 'isEnVersion', 'userRoles', 'eventClaims', 'claims']),
            customDateTimeFormat() {
                return `{0: ${this.dateTimeFormat}}`;
            },
            token: function () {
                return this.$store.getters.authToken;
            },
            userSettings() {
                let grid = this.$refs.formsGrid.kendoWidget();
                return grid.getOptions();
            },
            toolbar: function () {
                return [{ name: 'excel', text: this.$t('buttons.excelExport.tooltipText') }]
            },
            hasFormCreateRights() {
                return this.claims.formSurvey.create;
            },
            hasFormEditRights() {
                return this.claims.formSurvey.update;
            },
            hasFormDetailsRights() {
                return this.claims.formSurvey.read
                    || (this.eventClaims && this.eventClaims[EventClaims.EventFormManagement].read);
            },
            hasDeleteRights() {
                return this.claims.formSurvey.delete
                    || (this.eventClaims && this.eventClaims[EventClaims.EventFormManagement].delete);
            },
            hasEventId() {
                return !isNaN(this.relatedEventId) && this.relatedEventId > 0;
            },
            hasEventDetailsRights() {
                return this.$store.getters.claims.eventDetails.read;
            },
            hasFormSummaryRights() {
                return this.claims.formSurvey.read
                    || (this.eventClaims && this.eventClaims[EventClaims.EventFormManagement].read);
            },
            hasActivateDeactivateRights() {
                return this.claims.formSurvey.update
                    || (this.eventClaims && this.eventClaims[EventClaims.EventFormManagement].update);
            },
            hasCopyRights() {
                return this.claims.formSurvey.create;
            }
        },
        watch: {
            formsFilter: function (val) {
                if (this.hasEventId) {
                    return;
                }
                this.refresh();
            }
        }
    }
</script>


<style>
    /*
        Use the DejaVu Sans font for display and embedding in the PDF file.
        The standard PDF fonts have no support for Unicode characters.
    */
    .k-pdf-export .k-grid {
        font-family: "DejaVu Sans", "Arial", sans-serif;
    }

    .k-pdf-export .k-filterable .k-grid-filter {
        display: none;
    }

    .k-pdf-export .k-with-icon .k-header-column-menu {
        display: none;
    }

    .k-grid .k-grid-header .k-header .k-link {
        height: auto;
    }

    .k-grid .k-grid-header .k-header {
        white-space: normal;
    }

    .k-grid-edit, .k-grid-details, .k-grid-delete, .k-grid-pdf, .k-grid-excel {
        padding: 0;
        margin-bottom: 2px;
    }
</style>

<style lang="scss">
    tr.left-border-danger {
        &:hover

    {
        color: rgba(255, 0, 0, 0.7) !important;
    }

    td:first-child {
        border-left: 3px solid rgba(255, 0, 0, 0.5) !important;
    }

    }

    tr.left-border-blue {
        &:hover

    {
        color: #3498db !important;
    }

    td:first-child {
        border-left: 3px solid #3498db !important;
    }

    }

    tr.left-border-green {
        &:hover

    {
        color: #4caf50 !important;
    }

    td:first-child {
        border-left: 3px solid #4caf50 !important;
    }
    }
</style>
